<template>
  <v-row class="imageBlock no-gutters">
    <transition appear name="from-below">
      <v-col cols="12" :sm="full ? 12 : 6">
        <img :src="url"/>
      </v-col>
    </transition>
  </v-row>
</template>

<script>
export default {
  name: 'ContentImage',
  props: {
    data: {
      type: Object,
      required: true
    },
    full: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    url () {
      return `/media/${this.data.image.id}`
    }
  }
}
</script>

<style scoped lang="scss">
  img {
    max-width: 100%;
  }
</style>
